import { gql } from '@apollo/client';

/**
 * Adoption across every interview chat. No filters and no rows: the channel list, its
 * search, sorting and paging come from the GetStream SDK, so this stays a fixed-cost call
 * made once when the page loads.
 */
export const GET_INTERVIEW_CHAT_SUMMARY = gql`
  query BoInterviewChatSummary {
    interviewChatSummary {
      provisioned
      activated
      activeLast7Days
      activeLast30Days
      activationRatePct
      byState {
        state
        count
      }
      newChatsByDay {
        bucketStart
        newChats
      }
      scannedChats
      truncated
      scanFailed
      generatedAt
    }
  }
`;

/** Context for the selected chat: the interview it is anchored to. */
export const GET_INTERVIEW_FOR_CHAT = gql`
  query BoGetInterviewForChat($input: GetInterviewsInput!) {
    getInterviews(input: $input) {
      entities {
        id
        status
        createdAt
        completedAt
        finalStreamTitle
        scheduleEvent {
          id
          startTs
        }
      }
    }
  }
`;
